import * as MobX from "mobx";

import { IsNotEmpty } from "class-validator";
// Libs
import { ModelBase } from "@shoothill/core";

// App

export class Role extends ModelBase<Role, RoleDTO> {
    public id: string = "";
    @IsNotEmpty({ message: "Name is required" })
    @MobX.observable
    public name: string = "";

    constructor(id: string) {
        super();
        this.id = id;
    }

    @MobX.action
    public fromDto = (model: RoleDTO) => {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                (this as any)[key] = (model as any)[key];
            }
        }
    };

    public toDto = (model: Role) => {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                (model as any)[key] = (this as any)[key];
            }
        }
    };
}

export interface RoleDTO {
    id: string;
    name: string;
}
